import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";
import NoteProjectContactEdit from '../../components/Notes/NoteProjectContactEdit';

const ProjectContactNoteEdit = ({classes, note, projectContactNote, project, contact}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('notes.note_add')}
        />

        <Card>
            <CardContent>
                <NoteProjectContactEdit
                    values={{...note, ...projectContactNote}}
                    project={project}
                    contact={contact}
                />
            </CardContent>
        </Card>
    </Layout>
);

export default ProjectContactNoteEdit;
